import React, { useContext } from 'react';
import { Avatar, Backdrop, Box, Dialog, DialogContent, Grid, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import huBg from '../assets/img/hu_bg.png';
import { ArrowRight, Exit, XmarkCircle } from '@vectopus/atlas-icons-react';
import { AppContext } from '@/utils/appContext';


const ModalProfile = (props: any) => {


  const { classes } = useStyles();
  const { t } = useTranslation();

  const { accountData, handleLogout } = useContext(AppContext);


  // @ts-ignore
  return (
    <Dialog
      open={props.params.openProfileModal}
      onClose={() => props.params.setOpenProfileModal(false)}
      closeAfterTransition
      maxWidth={'lg'}
      BackdropComponent={Backdrop}
      className={classes.modal}
      BackdropProps={{
        timeout: 500
      }}>
      <DialogContent className={classes.root}>
        <Grid
          container
          alignItems={'center'}
          justifyContent={'space-evenly'}
          direction={'row'}
          className={classes.header}>
          <Grid item xs={12} sx={{ backgroundColor: '#2357d0' }}>
            <Box onClick={() => props.params.setOpenProfileModal(false)}>
              <XmarkCircle size={24} />
            </Box>
            <Grid
              container
              alignItems={'center'}
              justifyContent={'space-evenly'}
              direction={'row'}
              style={{ backgroundImage: `url(${huBg})` }}
              spacing={2}
              p={4}
            >
              <Grid item xs={8}>
                <Box>
                  <Typography variant={'body2'} component={'p'}>
                    Ciao,
                  </Typography>
                  <Typography variant={'h3'} component={'h3'}>
                    {accountData?.firstName}
                  </Typography>
                </Box>

                {
                  accountData?.loyalty && accountData.loyalty.points > 0 && (
                    <Box mt={2}>
                      <Typography variant={'body2'} component={'p'}>
                        {t('Saldo')} Huniverse Card:
                      </Typography>
                      <Typography variant={'h5'} component={'h5'}>
                        {accountData?.loyalty?.points}
                      </Typography>
                    </Box>
                  )
                }
              </Grid>

              <Grid item xs={4}>
                <Avatar
                  alt={`${accountData?.firstName} ${accountData?.lastName}`}
                  src={''}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Box pt={3} pb={2} pr={4} pl={4}>
          <Typography variant={'h4'} component={'h4'} mb={2}>{t('account_settings')}</Typography>
          <Grid container direction={'row'} alignItems={'center'} justifyContent={'space-between'}
                sx={{ borderBottom: '1px solid #c6c6c6' }} pb={1}>
            <Grid item xs={10}>
              <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={() => handleLogout()}>
                <Exit size={12} /><Typography variant={'body2'} component={'p'} pl={1}>{t('Logout')}</Typography>
              </Box>
            </Grid>
            <Grid item xs={2} textAlign={'right'}>
              <ArrowRight size={12} />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalProfile;

const useStyles = makeStyles()((theme) => {
  return {
    root: {
      padding: 0
    },
    header: {
      color: '#FFF',
      svg: {
        position: 'absolute',
        right: 13,
        top: 13
      },
      '.MuiAvatar-root': {
        float: 'right',
        width: 80,
        height: 80
      }
    },
    modal: {
      margin: 'auto',
      overflow: 'scroll',
      zIndex: 0,
      '& .MuiDialog-paper': {
        maxWidth: '100%',
        width: '100%!important',
        maxHeight: '100%',
        margin: 0,
        height: '100%'
      },
      '& .MuiBackdrop-root': {
        backgroundColor: 'transparent!important'
      },
      [theme.breakpoints.down('sm')]: {
        zIndex: 999999,
        paddingTop: 0
      }
    }
  };
});
